module.exports = __webpack_public_path__ + "static/img/3_2_2.0b228f19.jpg";